<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentFAQTile
      v-for="(faq, i) in faqs"
      :key="i"
      :color="faq.color"
      :question="faq.question"
      :answerArray="faq.answerArray"
      :graphic="faq.graphic"
    >
      <v-col
        v-if="faq.highlightText !== null"
        slot="content"
        cols="12"
      >
        <v-card
          flat
        >
          <v-card-text
            :style="{
              'color': faq.color
            }">
            {{ faq.highlightText }}
          </v-card-text>
        </v-card>
      </v-col>
    </ContentFAQTile>
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('tfaq.footer.title')"
      :textArray="[$t('tfaq.footer.p0')]"
      :downloadText="$t('tfaq.footer.download')"
      downloadFileName="Hans-Lebrecht-Schule_FAQ.pdf"
    >
      <v-row
        slot="content"
      >
        <v-col
          cols="12"
          align="center"
        >
          <InternalLinkButton
            :themeColor="computedTopicColor"
            pageName="Contact"
            :text="$t('tfaq.footer.contact')"
          />
        </v-col>
      </v-row>
    </ContentTile>
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'
import { FAQ_COLORS } from '@/plugins/colors'
import ContentFrame from '@/views/components/ContentFrame.vue'
import ContentFAQTile from '@/views/components/ContentFAQTile.vue'
import ContentTile from '@/views/components/ContentTile.vue'
import InternalLinkButton from '@/views/components/InternalLinkButton.vue'

export default {
  name: 'TFAQ',
  components: {
    ContentFrame,
    ContentFAQTile,
    ContentTile,
    InternalLinkButton
  },
  computed: {
    ...mapGetters(['menuData']),
    computedTopicColor () {
      return this.menuData.tFaq.color
    },
    computedTitle () {
      return this.menuData.tFaq.title
    },
    faqs () {
      return [
        {
          color: FAQ_COLORS[0],
          question: this.$t('tfaq.q0.question'),
          answerArray: [this.$t('tfaq.q0.a0'), this.$t('tfaq.q0.a1'), this.$t('tfaq.q0.a2')],
          highlightText: this.$t('tfaq.q0.highlight'),
          graphic: '/img/fragen/haus.png'
        },
        {
          color: FAQ_COLORS[1],
          question: this.$t('tfaq.q1.question'),
          answerArray: [this.$t('tfaq.q1.a0'), this.$t('tfaq.q1.a1')],
          highlightText: null,
          graphic: '/img/fragen/erstetage.png'
        },
        {
          color: FAQ_COLORS[2],
          question: this.$t('tfaq.q2.question'),
          answerArray: [this.$t('tfaq.q2.a0'), this.$t('tfaq.q2.a1'), this.$t('tfaq.q2.a2')],
          highlightText: null,
          graphic: '/img/fragen/lehrerinnen.png'
        },
        {
          color: FAQ_COLORS[3],
          question: this.$t('tfaq.q3.question'),
          answerArray: [
            this.$t('tfaq.q3.a0'),
            this.$t('tfaq.q3.a1'),
            this.$t('tfaq.q3.a2'),
            this.$t('tfaq.q3.a3'),
            this.$t('tfaq.q3.a4')
          ],
          highlightText: null,
          graphic: '/img/fragen/kennenlernen.png'
        },
        {
          color: FAQ_COLORS[4],
          question: this.$t('tfaq.q4.question'),
          answerArray: [this.$t('tfaq.q4.a0'), this.$t('tfaq.q4.a1'), this.$t('tfaq.q4.a2')],
          highlightText: null,
          graphic: '/img/fragen/stundenplan.png'
        },
        {
          color: FAQ_COLORS[5],
          question: this.$t('tfaq.q5.question'),
          answerArray: [
            this.$t('tfaq.q5.a0'),
            this.$t('tfaq.q5.a1'),
            this.$t('tfaq.q5.a2'),
            this.$t('tfaq.q5.a3')
          ],
          highlightText: null,
          graphic: '/img/fragen/einzel.png'
        },
        {
          color: FAQ_COLORS[6],
          question: this.$t('tfaq.q6.question'),
          answerArray: [
            this.$t('tfaq.q6.a0'),
            this.$t('tfaq.q6.a1'),
            this.$t('tfaq.q6.a2'),
            this.$t('tfaq.q6.a3')
          ],
          highlightText: null,
          graphic: '/img/fragen/tueroffen.png'
        },
        {
          color: FAQ_COLORS[7],
          question: this.$t('tfaq.q7.question'),
          answerArray: [
            this.$t('tfaq.q7.a0'),
            this.$t('tfaq.q7.a1'),
            this.$t('tfaq.q7.a2'),
            this.$t('tfaq.q7.a3'),
            this.$t('tfaq.q7.a4'),
            this.$t('tfaq.q7.a5')
          ],
          highlightText: null,
          graphic: '/img/fragen/bericht.png'
        },
        {
          color: FAQ_COLORS[8],
          question: this.$t('tfaq.q8.question'),
          answerArray: [this.$t('tfaq.q8.a0'), this.$t('tfaq.q8.a1')],
          highlightText: this.$t('tfaq.q8.highlight'),
          graphic: '/img/fragen/taube.png'
        },
        {
          color: FAQ_COLORS[9],
          question: this.$t('tfaq.q9.question'),
          answerArray: [this.$t('tfaq.q9.a0'), this.$t('tfaq.q9.a1')],
          highlightText: null,
          graphic: '/img/fragen/klinik.png'
        },
        {
          color: FAQ_COLORS[10],
          question: this.$t('tfaq.q10.question'),
          answerArray: [this.$t('tfaq.q10.a0'), this.$t('tfaq.q10.a1'), this.$t('tfaq.q10.a2')],
          highlightText: null,
          graphic: '/img/fragen/bericht.png'
        }
      ]
    }
  }
}
</script>
